import React from "react";

function GirlGroup() {
  return (
    <section>
      <div>
        <img src="./img/groupgirls.png" alt="group-girls" />
      </div>
    </section>
  );
}

export default GirlGroup;
